module.exports = __webpack_public_path__ + "static/img/body3.6e2e547.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body3.jpeg
// module id = CVBM
// module chunks = 1